@if (data && hasData()) {
<div class="consumer-insights-container">
    <!-- Hide for now: Consumer-Centric Performance Metrics -->
    <!-- 
    @if(data?.data && data.data.length > 0){
    <div class="overview-section">
        <h2 class="section-title">
            <mat-icon>dashboard</mat-icon>
            Consumer-Centric Performance Metrics
        </h2>
        <app-score-cards [universities]="data.data"
            [metrics]="['Customer Satisfaction', 'Purchase Intent', 'Brand Loyalty', 'Value Perception', 'Brand Awareness']"
            [title]="'Brand performance by metric'">
        </app-score-cards>
    </div>
    }
    -->

    <!-- Comparison Summary (Yours compared to others) -->
    <!-- @if(getComparisonSummaryText()){
    <div class="comparison-summary-section">
        <h2 class="section-title">
            <mat-icon>compare_arrows</mat-icon>
            Comparison Summary (Yours compared to others)
        </h2>
        <p class="comparison-summary-text">{{ getComparisonSummaryText() }}</p>
    </div>
    } -->

    <!-- Consumer Insights Summary Table -->
    <!-- @if(hasCombinedData()){
    <div class="table-container">
        <h2 class="section-title">
            <mat-icon>table_chart</mat-icon>
            Consumer Insights Summary
        </h2>
        <app-table [dataSource]="combinedTableData" [columns]="combinedTableColumns"
            [displayedColumns]="getCombinedTableColumns()">
        </app-table>
    </div>
    } -->

    <!-- Consumer Metrics Radar Chart -->
    @if(satisfactionRadarData.length > 0){
    <div class="chart-section">
        <h2 class="section-title">
            <mat-icon>sentiment_satisfied</mat-icon>
            Consumer Metrics Analysis
        </h2>
        <div class="chart-container">
            <app-area-chart [areaChartData]="satisfactionRadarData" [scheme]="'vivid'" [animations]="true" [legend]="false" [xAxis]="true" [yAxis]="true" [showXAxisLabel]="false" [showYAxisLabel]="false" [xAxisLabel]="''" [yAxisLabel]="''">
            </app-area-chart>
        </div>
    </div>
    }

    <!-- Demographics Section -->
    @if(hasDemographicsData()){
    <div class="demographics-section">
        <h2 class="section-title">
            <mat-icon>people</mat-icon>
            Consumer Demographics
        </h2>
        <p class="section-description">Demographic insights based on search patterns and market data </p>
        <!-- (from {{ getTotalSurveyed() }} surveyed people) -->
        
        <div class="demographics-grid">
            <!-- Gender Chart -->
            @if(genderChartData.length > 0){
            <mat-card class="demographics-card">
                <mat-card-header>
                    <mat-card-title>Gender Distribution</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="chart-wrapper">
                        <app-pie-chart
                            [view]="demographicsChartView"
                            [results]="genderChartData"
                            [animations]="true"
                            [legend]="true"
                            [legendTitle]="'Gender Distribution'"
                            [tooltipDisabled]="false">
                        </app-pie-chart>
                    </div>
                    <div class="chart-details">
                        @for(item of genderChartData; track item.name){
                        <div class="detail-item">
                            <strong>{{ item.name }}:</strong> {{ item.description }}
                        </div>
                        }
                    </div>
                </mat-card-content>
            </mat-card>
            }

            <!-- Age Chart -->
            @if(ageChartData.length > 0){
            <mat-card class="demographics-card">
                <mat-card-header>
                    <mat-card-title>Age Distribution</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="chart-wrapper">
                        <app-pie-chart
                            [view]="demographicsChartView"
                            [results]="ageChartData"
                            [animations]="true"
                            [legend]="true"
                            [legendTitle]="'Age Distribution'"
                            [tooltipDisabled]="false">
                        </app-pie-chart>
                    </div>
                    <div class="chart-details">
                        @for(item of ageChartData; track item.name){
                        <div class="detail-item">
                            <strong>{{ item.name }}:</strong> {{ item.description }}
                        </div>
                        }
                    </div>
                </mat-card-content>
            </mat-card>
            }

            <!-- Interest Chart -->
            @if(interestChartData.length > 0){
            <mat-card class="demographics-card">
                <mat-card-header>
                    <mat-card-title>Interest Categories</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="chart-wrapper">
                        <app-pie-chart
                            [view]="demographicsChartView"
                            [results]="interestChartData"
                            [animations]="true"
                            [legend]="true"
                            [legendTitle]="'Interest Categories'"
                            [tooltipDisabled]="false">
                        </app-pie-chart>
                    </div>
                    <div class="chart-details">
                        @for(item of interestChartData; track item.name){
                        <div class="detail-item">
                            <strong>{{ item.name }}:</strong> {{ item.description }}
                        </div>
                        }
                    </div>
                </mat-card-content>
            </mat-card>
            }

            <!-- User Types Chart -->
            @if(userTypesChartData.length > 0){
            <mat-card class="demographics-card">
                <mat-card-header>
                    <mat-card-title>User Types</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="chart-wrapper">
                        <app-pie-chart
                            [view]="demographicsChartView"
                            [results]="userTypesChartData"
                            [animations]="true"
                            [legend]="true"
                            [legendTitle]="'User Types'"
                            [tooltipDisabled]="false">
                        </app-pie-chart>
                    </div>
                    <div class="chart-details">
                        @for(item of userTypesChartData; track item.name){
                        <div class="detail-item">
                            <strong>{{ item.name }}:</strong> {{ item.description }}
                        </div>
                        }
                    </div>
                </mat-card-content>
            </mat-card>
            }
        </div>

        <!-- Additional Demographics -->
        <!-- @if(additionalDemographics.length > 0){
        <div class="additional-demographics-section">
            <h3 class="subsection-title">
                <mat-icon>more_horiz</mat-icon>
                Additional Demographics
            </h3>
            <div class="additional-demographics-grid">
                @for(demo of additionalDemographics; track demo.category){
                <mat-card class="additional-demo-card">
                    <mat-card-header>
                        <mat-card-title>
                            <mat-icon class="category-icon">category</mat-icon>
                            {{ demo.category }}
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        @if(demo.data && isArray(demo.data)){
                        <div class="demo-data-list">
                            @for(item of demo.data; track item.name){
                            <div class="demo-data-item">
                                <div class="demo-item-header">
                                    <strong>{{ item.name }}</strong>
                                    <span class="demo-percentage">{{ item.percentage }}%</span>
                                </div>
                                <div class="demo-item-description">{{ item.description }}</div>
                            </div>
                            }
                        </div>
                        }
                    </mat-card-content>
                </mat-card>
                }
            </div>
        </div>
        } -->
    </div>
    }

    <!-- Consumer Behavior Integration Section -->
    @if(hasConsumerBehaviorData()){
    <div class="consumer-behavior-section">
        <h2 class="section-title">
            <mat-icon>psychology</mat-icon>
            Consumer Behavior Analytics
        </h2>

        <div class="behavior-analytics-grid">
            <!-- Purchase Analytics -->
            @if(purchaseAnalytics){
            <mat-card class="behavior-card">
                <mat-card-header>
                    <mat-card-title>
                        <mat-icon>shopping_cart</mat-icon>
                        Purchase Analytics
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="analytics-stats">
                        <div class="stat-item">
                            <div class="stat-icon-wrapper">
                                <mat-icon>trending_up</mat-icon>
                            </div>
                            <div class="stat-content">
                                <span class="stat-label">Average Purchase Frequency</span>
                                <span class="stat-value">{{ purchaseAnalytics.average_purchase_frequency ? Math.round(purchaseAnalytics.average_purchase_frequency) : 'N/A' }}</span>
                            </div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-icon-wrapper">
                                <mat-icon>monetization_on</mat-icon>
                            </div>
                            <div class="stat-content">
                                <span class="stat-label">Customer Lifetime Value</span>
                                <span class="stat-value">{{ purchaseAnalytics.customer_lifetime_value ? Math.round(purchaseAnalytics.customer_lifetime_value) : 'N/A' }}</span>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            }

            <!-- Customer Preferences -->
            @if(customerPreferences){
            <mat-card class="behavior-card">
                <mat-card-header>
                    <mat-card-title>
                        <mat-icon>favorite</mat-icon>
                        Customer Preferences
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="preferences-content">
                        <h4 class="preferences-subtitle">Top Preferences</h4>
                        <mat-chip-set>
                            @for(preference of customerPreferences.top_preferences; track preference){
                            <mat-chip color="accent">{{ preference }}</mat-chip>
                            }
                        </mat-chip-set>
                    </div>
                </mat-card-content>
            </mat-card>
            }

        </div>
    </div>
    }

    <!-- Comparative Insights Section -->
    @if(hasComparativeInsights()){
    <div class="comparative-section">
        <h2 class="section-title">
            <mat-icon>compare</mat-icon>
            Comparative Analysis
        </h2>

        <div class="insights-grid">
            <mat-card class="insight-card">
                <mat-card-header>
                    <mat-card-title>Top Performer</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p><strong>{{ comparativeInsights.top_performer }}</strong></p>
                </mat-card-content>
            </mat-card>

            <mat-card class="insight-card">
                <mat-card-header>
                    <mat-card-title>Average Score</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p class="score-value">{{ comparativeInsights.average_score ? Math.round(comparativeInsights.average_score) : '' }}</p>
                </mat-card-content>
            </mat-card>

            <mat-card class="insight-card">
                <mat-card-header>
                    <mat-card-title>Key Differentiators</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-list>
                        @for(differentiator of comparativeInsights.key_differentiators; track differentiator){
                        <mat-list-item>
                            <mat-icon matListItemIcon>check_circle</mat-icon>
                            <div matListItemTitle>{{ differentiator }}</div>
                        </mat-list-item>
                        }
                    </mat-list>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    }

    <!-- HIDDEN: Data Sources & Evidence (do not remove)
    @if (getCitations().length > 0) {
    <app-citation-card [citations]="getCitations()" [title]="'Data Sources & Evidence'" [displayStyle]="'grid'"
        [maxDisplay]="6">
    </app-citation-card>
    }
    -->

    <!-- Recommendations Section -->
    @if(recommendations.length > 0){
    <div class="recommendations-section">
        <h2 class="section-title">
            <mat-icon>lightbulb</mat-icon>
            Strategic Recommendations
        </h2>
        <div class="recommendations-grid">
            @for(rec of recommendations; track rec.category){
            <mat-card class="recommendation-card" [class]="'priority-' + rec.priority.toLowerCase()">
                <mat-card-header>
                    <mat-card-title>{{ rec.category }}</mat-card-title>
                    <mat-card-subtitle>
                        <span class="priority-badge" [class]="'priority-' + rec.priority.toLowerCase()">
                            {{ rec.priority }}
                        </span>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <div class="recommendation-content">
                        <div class="issue-section">
                            <h4>Issue:</h4>
                            <p>{{ rec.issue }}</p>
                        </div>
                        <div class="recommendation-section">
                            <h4>Recommendation:</h4>
                            <p>{{ rec.recommendation }}</p>
                        </div>
                        <div class="impact-section">
                            <h4>Expected Impact:</h4>
                            <p>{{ rec.expected_impact }}</p>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            }
        </div>
    </div>
    }
</div>
}

